/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PhoneAreaCodeSelect.vue?vue&type=template&id=4bd9ea7a&"
import script from "./PhoneAreaCodeSelect.vue?vue&type=script&lang=js&"
export * from "./PhoneAreaCodeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports